var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurancePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.9565C23.3583 20.9565 24.5583 21.2808 25.5333 21.7049C26.4333 22.104 27 23.0021 27 23.9749V27.9633C27 27.9633 25.5 28.8438 22 28.8438C18.5 28.8438 17 27.9633 17 27.9633V23.9833C17 23.0021 17.5667 22.104 18.4667 21.7132C19.4417 21.2808 20.6417 20.9565 22 20.9565ZM15.3333 21.1644C16.25 21.1644 17 20.416 17 19.5014C17 18.5867 16.25 17.8383 15.3333 17.8383C14.4167 17.8383 13.6667 18.5867 13.6667 19.5014C13.6667 20.416 14.4167 21.1644 15.3333 21.1644ZM16.275 22.0791C15.9667 22.0292 15.6583 21.9959 15.3333 21.9959C14.5083 21.9959 13.725 22.1705 13.0167 22.4782C12.4 22.7443 12 23.343 12 24.0165C12 24.0165 12 25.322 12 26.2024C12 27.0829 15.75 27.3764 15.75 27.3764V23.9833C15.75 23.2931 15.9417 22.6445 16.275 22.0791ZM28.6667 21.1644C29.5833 21.1644 30.3333 20.416 30.3333 19.5014C30.3333 18.5867 29.5833 17.8383 28.6667 17.8383C27.75 17.8383 27 18.5867 27 19.5014C27 20.416 27.75 21.1644 28.6667 21.1644ZM32 24.0165C32 23.343 31.6 22.7443 30.9833 22.4782C30.275 22.1705 29.4917 21.9959 28.6667 21.9959C28.3417 21.9959 28.0333 22.0292 27.725 22.0791C28.0583 22.6445 28.25 23.2931 28.25 23.9833V27.3764C28.25 27.3764 32 27.0829 32 26.2024C32 25.322 32 24.0165 32 24.0165ZM22 15.3438C23.3833 15.3438 24.5 16.458 24.5 17.8383C24.5 19.2186 23.3833 20.3329 22 20.3329C20.6167 20.3329 19.5 19.2186 19.5 17.8383C19.5 16.458 20.6167 15.3438 22 15.3438Z",
    fill: "#5A89FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 17.5,
    stroke: "#5A89FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 4,
    r: 2.5,
    fill: "#5A89FF",
    stroke: "#D6E4FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 40,
    r: 2.5,
    fill: "#5A89FF",
    stroke: "#D6E4FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.40979,
    cy: 13.0023,
    r: 2.5,
    transform: "rotate(-60 6.40979 13.0023)",
    fill: "#5A89FF",
    stroke: "#D6E4FB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5875,
    cy: 31.0023,
    r: 2.5,
    transform: "rotate(-60 37.5875 31.0023)",
    fill: "#5A89FF",
    stroke: "#D6E4FB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.40588,
    cy: 31.0023,
    r: 2.5,
    transform: "rotate(-120 6.40588 31.0023)",
    fill: "#5A89FF",
    stroke: "#D6E4FB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5836,
    cy: 13.0023,
    r: 2.5,
    transform: "rotate(-120 37.5836 13.0023)",
    fill: "#5A89FF",
    stroke: "#D6E4FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurancePlan);
export default __webpack_public_path__ + "static/media/insurance-plan.9bc3dd69ca1a50b3ea1db4034a28b6a8.svg";
export { ForwardRef as ReactComponent };